/* eslint no-useless-escape: 0 */

module.exports = {
  addressFormat: 'addressLine1,addressLine2,postalCode,city',
  products: [
    {
      id: '1',
      refId: '1',
      name: 'Online',
      isShippingAddressRequired: false,
      st: 'DIGITAL',
    },
    {
      id: '2',
      refId: '2',
      name: 'Meetings',
      isShippingAddressRequired: true,
      st: 'WORKSHOP,STUDIO',
    },
    {
      id: '8',
      refId: '1',
      name: 'eTools',
      isShippingAddressRequired: false,
    },
    {
      id: '14',
      refId: '1',
      name: 'Online iTunes',
      isShippingAddressRequired: false,
    },
    {
      id: '22',
      refId: '0',
      name: 'Virtual Group Coaching + Digital',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
    },
    {
      id: '23',
      refId: '0',
      name: 'Virtual Community',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
      st: 'VIRTUAL_COMMUNITY',
    },
    {
      id: '24',
      refId: '0',
      name: 'Virtual Community + Workshop',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
      st: 'WORKSHOP_VIRTUAL_COMMUNITY',
    },
    {
      id: '25',
      refId: '0',
      name: 'Digital360 iTunes',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
    },
    {
      id: '27',
      refId: '0',
      name: 'Digital360 Android',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
    },
  ],
  validations: {
    firstName: {},
    lastName: {},
    addressLine1: {
      regex:
        "^[A-Za-zÀÂÅÄÈÉÊËÎÏÖÔŒÙÛÜŸàâåäèéêëîïöôœùûüÿÇç€0-9\\. /\\-',#]*[A-Za-zÀÂÅÄÈÉÊËÎÏÖÔŒÙÛÜŸàâåäèéêëîïöôœùûüÿÇç€]+[A-Za-zÀÂÅÄÈÉÊËÎÏÖÔŒÙÛÜŸàâåäèéêëîïöôœùûüÿÇç€0-9\\. /\\-',#]*$",
    },
    addressLine2: {
      regex:
        "^$|^[A-Za-zÀÂÅÄÈÉÊËÎÏÖÔŒÙÛÜŸàâåäèéêëîïöôœùûüÿÇç€0-9\\. /\\-',#]*[A-Za-zÀÂÅÄÈÉÊËÎÏÖÔŒÙÛÜŸàâåäèéêëîïöôœùûüÿÇç€]+[A-Za-zÀÂÅÄÈÉÊËÎÏÖÔŒÙÛÜŸàâåäèéêëîïöôœùûüÿÇç€0-9\\. /\\-',#]*$",
    },
    city: {
      regex:
        '^[a-zA-ZÄÅäÖößÜüåé. -]*[a-zA-ZÄÅäÖößÜüåé]+[a-zA-ZÄÅäÖößÜüåé. -]*$',
    },
    state: {
      required: true,
    },
    postalCode: {
      type: 'string',
      min: 5,
      max: 5,
      regex: '^\\d{5}$',
      regexFlags: '',
      numbersOnly: true,
    },
    ccNumber: {
      min: 8,
      max: 20,
    },
    ccCVVNo: {},
    pinNumber: {
      show: true,
      required: false,
      min: 1,
      max: 13,
    },
  },
  payment: {
    modes: ['FLEX', 'CC', 'PP'],
    supportedCCs: [
      { id: 1, tid: 21, name: 'VISA', ccName: 'VISA' },
      { id: 2, tid: 22, name: 'MASTERCARD', ccName: 'MASTER CARD' },
      { id: 3, tid: 23, name: 'AMERICAN EXPRESS', ccName: 'AMERICAN EXPRESS' },
    ],
  },
};
